export interface HotEvent {
  rank: number;
  tag: string;
  title: string;
  summary: string;
  heat: string;
  delta: number;
}

export interface Phase {
  step: string;
  tone: "coral" | "amber" | "tan";
  time: string;
  title: string;
  text: string;
}

export interface EventCard {
  cat: string;
  title: string;
  summary: string;
  cover: string;
  views: string;
  update: string;
}

export interface Faq {
  q: string;
  a: string;
}

export const heroStats = [
  { value: "2,300+", label: "已梳理热门事件" },
  { value: "4.8 万条", label: "时间线节点" },
  { value: "36 个", label: "实时追踪专题" },
  { value: "每日 09:00", label: "热榜固定更新" },
];

export const hotEvents: HotEvent[] = [
  {
    rank: 1,
    tag: "直播行业",
    title: "主播「陪跑局」剧本被扒，直播间连麦翻车始末",
    summary: "一段连麦录音外流，把「剧本吵架」的底稿抖了个干净，前因后果逐渐对上了。",
    heat: "982.4w",
    delta: 1,
  },
  {
    rank: 2,
    tag: "品牌商业",
    title: "国货联名又翻车？设计师道歉信流出时间线还原",
    summary: "从预热海报到上线当天，三次口径反转，完整经过我们按节点替你清点了一遍。",
    heat: "876.9w",
    delta: 2,
  },
  {
    rank: 3,
    tag: "素人走红",
    title: "一夜涨粉百万的素人，为什么十天后选择退网",
    summary: "走红、接广、被考古、开撕、退网，五天五步，脉络图已把前因后果排得明明白白。",
    heat: "741.2w",
    delta: -1,
  },
  {
    rank: 4,
    tag: "文娱内容",
    title: "综艺「断章取义」名场面再发酵，正片与切片对不上",
    summary: "完整对话内容被逐句拼回后，网友发现「塌房」原来只是剪辑的锅。",
    heat: "633.5w",
    delta: 3,
  },
  {
    rank: 5,
    tag: "机构生态",
    title: "头部机构「兄弟情」集体出走，合约与分成争议复盘",
    summary: "一纸分成细则流出，把机构与达人之间积累半年的怨气彻底点燃。",
    heat: "518.7w",
    delta: -2,
  },
  {
    rank: 6,
    tag: "圈层文化",
    title: "考古旧梗疯狂二创，谁让「冷门神曲」一夜回春",
    summary: "一段十五年前的现场被重新剪成爆款，原始出处我们替你追到了源头。",
    heat: "402.1w",
    delta: 5,
  },
];

export const featuredTags = ["事件追踪", "已完结", "多方求证"];

export const featured = {
  title: "素人一夜涨粉百万，为何十天后退网",
  intro:
    "本期用一张脉络图 + 六段时间线，把「突然走红 → 资本进场 → 考古翻车 → 情绪反噬 → 公开退网」的完整经过拆开，逐节点对齐信源与口径，前因后果一次看明白。",
  phases: [
    {
      step: "起因",
      tone: "coral",
      time: "D+0",
      title: "一支 47 秒的户外视频走红",
      text: "视频被搬运至多个平台，播放量当天突破千万，账号一小时涌入几十万关注。",
    },
    {
      step: "发酵",
      tone: "amber",
      time: "D+1",
      title: "机构连夜私信，报价单被晒出",
      text: "数十家商务找上门，有人把百万级报价单公开，讨论开始从「有趣」转向「值多少」。",
    },
    {
      step: "反转",
      tone: "coral",
      time: "D+3",
      title: "素人被考古，旧言论连环被扒",
      text: "过去社交平台上的发言被逐条翻出，情绪从追捧快速倒向质疑与清算。",
    },
    {
      step: "激化",
      tone: "tan",
      time: "D+6",
      title: "澄清直播口误，再添一把火",
      text: "当事人开播回应，一句不严谨的表达被单独切片，舆情二次升温。",
    },
    {
      step: "收束",
      tone: "amber",
      time: "D+8",
      title: "机构发布联合声明停更",
      text: "双方口径首次统一，宣布暂停商务与更新，等待事件降温。",
    },
    {
      step: "结局",
      tone: "coral",
      time: "D+10",
      title: "账号置顶退网说明",
      text: "一条置顶声明结束整段高热度周期，事件进入复盘与长尾讨论阶段。",
    },
  ],
};

export const eventCats = [
  "全部",
  "素人走红",
  "品牌商业",
  "直播行业",
  "文娱内容",
  "机构生态",
  "圈层文化",
];

export const eventCards: EventCard[] = [
  {
    cat: "素人走红",
    title: "一张路人抓拍，食堂阿姨竟成全网顶流",
    summary: "从被路人拍到表情管理失控，到官号下场接梗，整条走红链路普通人都能看懂。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20cheerful%20ordinary%20cafeteria%20worker%20holding%20a%20spatula%20surrounded%20by%20floating%20hearts%2C%20likes%20icons%20and%20shooting%20star%20lines%20showing%20overnight%20fame%2C%20warm%20coral%20red%20and%20terracotta%20and%20soft%20amber%20on%20plain%20warm%20cream%20background%2C%20clean%20minimal%20composition%2C%20high%20detail%20flat%20art%20style&width=640&height=480&seq=card-viral-01&orientation=landscape",
    views: "312w",
    update: "2 小时前",
  },
  {
    cat: "品牌商业",
    title: "快餐品牌联名周边遭抢，黄牛价炒到十倍",
    summary: "限量周边上线即售罄，从饥饿营销质疑到二手溢价，一次联名背后全链路复盘。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20two%20clashing%20cute%20brand%20mascots%20fighting%20over%20a%20collectible%20badge%20with%20price%20tags%20and%20scalper%20arrows%20floating%20around%2C%20warm%20coral%20red%20terracotta%20and%20cream%20amber%20palette%20on%20plain%20cream%20background%2C%20clean%20minimal%20flat%20art%2C%20high%20detail&width=640&height=480&seq=card-brand-02&orientation=landscape",
    views: "198w",
    update: "5 小时前",
  },
  {
    cat: "直播行业",
    title: "直播带货新规落地，话术全面「去夸大」",
    summary: "平台细则一改，头部主播连夜改脚本，违禁词清单与处罚标准一次说清。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20live%20streaming%20setup%20with%20phone%20gimbal%20ring%20light%20and%20microphone%20next%20to%20an%20open%20rule%20notebook%20and%20gavel%20icon%2C%20warm%20coral%20red%20terracotta%20and%20soft%20amber%20on%20plain%20warm%20cream%20background%2C%20clean%20minimal%20flat%20art%2C%20high%20detail&width=640&height=480&seq=card-live-03&orientation=landscape",
    views: "142w",
    update: "8 小时前",
  },
  {
    cat: "文娱内容",
    title: "综艺神剪辑翻车，正片切片为何「两副面孔」",
    summary: "一段采访被切得语序颠倒，我们把原话逐句拼回，真相藏在被删掉的三十秒里。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20television%20monitor%20with%20a%20giant%20scissors%20cutting%20a%20speech%20ribbon%20into%20misleading%20pieces%20and%20question%20mark%20puzzles%20floating%20around%2C%20warm%20coral%20red%20terracotta%20cream%20amber%20palette%20on%20plain%20cream%20background%2C%20clean%20minimal%20flat%20vector%20art%2C%20high%20detail&width=640&height=480&seq=card-show-04&orientation=landscape",
    views: "126w",
    update: "昨天",
  },
  {
    cat: "机构生态",
    title: "达人集体出走头部公会，分成合同成导火索",
    summary: "六名中腰部达人同月解约，从分成比例到账号归属，纠纷焦点逐条拆解。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20cracked%20handshake%20between%20two%20stylized%20figures%20with%20scattered%20contract%20sheets%20and%20split%20coins%20icons%2C%20warm%20coral%20red%20terracotta%20and%20soft%20amber%20on%20plain%20warm%20cream%20background%2C%20clean%20minimal%20flat%20vector%20art%2C%20high%20detail&width=640&height=480&seq=card-agency-05&orientation=landscape",
    views: "98w",
    update: "昨天",
  },
  {
    cat: "圈层文化",
    title: "十五年前冷门现场被考古，为何突然全网回春",
    summary: "一段模糊饭拍被二创成爆款，从原视频溯源到版权归属，二次走红完整路径。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20an%20old%20vhs%20tape%20and%20retro%20camcorder%20connected%20by%20a%20rising%20trending%20chart%20line%20with%20rewind%20and%20share%20icons%20floating%2C%20warm%20coral%20red%20terracotta%20and%20amber%20on%20plain%20warm%20cream%20background%2C%20clean%20minimal%20flat%20vector%20art%2C%20high%20detail&width=640&height=480&seq=card-archive-06&orientation=landscape",
    views: "87w",
    update: "2 天前",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "建节点档案",
    text: "把每个事件按时间拆成最小可验证节点，标注首发信源与原文链接。",
  },
  {
    step: "02",
    title: "交叉对齐口径",
    text: "同一节点至少两方信源交叉，出现冲突时单独标注「存疑」，不强行定调。",
  },
  {
    step: "03",
    title: "补录反转与收尾",
    text: "追踪澄清、撤稿、声明等后续动作，事件有结果才进入完整经过档案。",
  },
  {
    step: "04",
    title: "定期复核修订",
    text: "公开档案每 30 天复核一次，新证据出现会即时更新并标注修订时间。",
  },
];

export const trustStats = [
  { value: "100%", label: "节点均标注首发信源" },
  { value: "2+", label: "每节点至少交叉信源" },
  { value: "30 天", label: "公开档案自动复核周期" },
  { value: "0", label: "不产出主观定论与站队" },
];

export const faqs: Faq[] = [
  {
    q: "「69吃瓜」整理的到底是哪一类事件？",
    a: "本站只收录引发大范围公开讨论、且链条足够清晰的网络热点事件，并对这类事件做中性的事件梳理与时间线还原。我们不追一次性碎片爆料，只做能撑起完整经过的专题。",
  },
  {
    q: "你们的信息都来自哪里，会不会被人带节奏？",
    a: "每个时间节点都会标注首发信源与可回溯链接，默认以当事人原文、机构声明、官方通报等一手资料为锚点。出现互相矛盾的口径时，我们会并列呈现并标记「存疑」，绝不替你下结论。",
  },
  {
    q: "发现某段经过与事实不符，怎么反馈修订？",
    a: "页面右侧的反馈入口可以提交证据与原文链接，经两名以上编辑核对无误后，会在 48 小时内更新对应节点，并在档案页注明修订时间。",
  },
  {
    q: "时间线里的「D+0 / D+1」是怎么算的？",
    a: "以事件首次被规模化公开讨论那一天记为 D+0，之后按自然日累进。用相对天数而非具体日期，是为了在不同平台版本间保持一致的叙事基准。",
  },
  {
    q: "同一事件的各方说法我都想看，去哪看？",
    a: "每个专题的脉络图下方都有「多方口径」折叠区，会把当事人、机构、平台、网友四个视角的原始说法原样陈列，方便你自己比对前因后果。",
  },
];

export const footerGroups = [
  { title: "热榜追踪", items: ["今日实时榜", "周热度总榜", "素人走红专题", "机构生态档案"] },
  { title: "梳理服务", items: ["事件脉络图", "完整时间线", "多方口径", "修订记录"] },
  { title: "关于本站", items: ["编辑准则", "信源标注规范", "反馈与修订", "联系我们"] },
];